var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnHeaderAccountHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 33.75L12.5 30.3818C12.5 27.0681 15.1863 24.3818 18.5 24.3818H25.5C28.8137 24.3818 31.5 27.0681 31.5 30.3818V33.75",
    stroke: "#4B68CF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2778 15.8056C16.2778 17.279 16.8631 18.6921 17.905 19.7339C18.9469 20.7758 20.36 21.3611 21.8334 21.3611C23.3068 21.3611 24.7199 20.7758 25.7618 19.7339C26.8036 18.6921 27.3889 17.279 27.3889 15.8056C27.3889 14.3321 26.8036 12.9191 25.7618 11.8772C24.7199 10.8353 23.3068 10.25 21.8334 10.25C20.36 10.25 18.9469 10.8353 17.905 11.8772C16.8631 12.9191 16.2778 14.3321 16.2778 15.8056Z",
    stroke: "#4B68CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnHeaderAccountHover);
export default __webpack_public_path__ + "static/media/btn_header_account_hover.b723a9ed4a0175946603bde6abb9464c.svg";
export { ForwardRef as ReactComponent };